import { useEffect } from 'react';
import { setCartBusiness } from '../app/features/cart/cartSlice';
import { useAppDispatch } from './hooks';

// Empties the persisted cart when the customer opens a different restaurant than the one it was filled at.
const useCartBusiness = (business: string | undefined) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (business) dispatch(setCartBusiness(business));
  }, [business]);
};

export default useCartBusiness;
